import { createContext, useContext } from 'react'
import type { Api } from './api'

/**
 * O cliente da API ao alcance das páginas. `AppProviders` o entrega; em teste e em story, recebe
 * um cliente com `fetch` falso (T25).
 */
export const ApiContext = createContext<Api | null>(null)

export function useApi(): Api {
  const api = useContext(ApiContext)
  if (!api) throw new Error('useApi precisa do AppProviders.')
  return api
}
